import { adjustUrlParams, isFullUrl, parseQueryParams } from '../utils';

/** expects the template url from dy, which is either a relative or absolute link
 * url, or just query params current url.  If only query params are given, these
 * will be merged with the source url */
export function combineLinkQueryWithUrl(dyLinkOrQuery: string, sourceUrl: string): string {
  if (!dyLinkOrQuery) {
    return sourceUrl;
  }

  // the dy-link-param is expected here.  It can either be a url (absolute or
  // relative), or contain only query params (filters)
  const linkIsRoute = dyLinkOrQuery.startsWith('/') || isFullUrl(dyLinkOrQuery);
  if (linkIsRoute) {
    return dyLinkOrQuery;
  }

  const paramsMap = parseQueryParams(dyLinkOrQuery);
  return adjustUrlParams(paramsMap, sourceUrl);
}
